import React from 'react';

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #F8F9FA 0%, #E8F5E9 100%)',
    fontFamily: "'Inter', sans-serif",
    color: '#1B3A5F',
    lineHeight: 1.7,
  },
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '60px 40px',
    background: 'white',
    minHeight: '100vh',
    boxShadow: '0 0 40px rgba(0,0,0,0.1)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingBottom: '30px',
    borderBottom: '3px solid #00B4A2',
  },
  logo: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#2D5A45',
    letterSpacing: '2px',
    marginBottom: '20px',
    textTransform: 'uppercase',
  },
  h1: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '42px',
    fontWeight: 300,
    color: '#1B3A5F',
    margin: '0 0 15px 0',
  },
  updated: {
    fontSize: '14px',
    color: '#6B7A8F',
    margin: 0,
  },
  section: {
    marginBottom: '40px',
  },
  h2: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '24px',
    fontWeight: 600,
    color: '#2D5A45',
    margin: '40px 0 20px 0',
    paddingBottom: '10px',
    borderBottom: '2px solid #E5E7EB',
  },
  h3: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '18px',
    fontWeight: 600,
    color: '#1B3A5F',
    margin: '25px 0 15px 0',
  },
  p: {
    fontSize: '16px',
    marginBottom: '15px',
    color: '#1B3A5F',
  },
  ul: {
    marginBottom: '20px',
    paddingLeft: '25px',
  },
  li: {
    fontSize: '16px',
    marginBottom: '10px',
    color: '#1B3A5F',
  },
  importantNotice: {
    background: 'linear-gradient(135deg, #FFF3E0, #FFECB3)',
    border: '1px solid #E67E50',
    borderLeft: '4px solid #E67E50',
    borderRadius: '8px',
    padding: '20px 25px',
    margin: '25px 0',
    fontSize: '15px',
  },
  legalFooter: {
    background: '#F8F9FA',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    padding: '25px',
    marginTop: '50px',
    textAlign: 'center',
  },
  backLink: {
    textAlign: 'center',
    marginTop: '40px',
    paddingTop: '30px',
    borderTop: '1px solid #E5E7EB',
  },
  link: {
    color: '#2D5A45',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '16px',
  },
  inlineLink: {
    color: '#00B4A2',
    textDecoration: 'none',
  },
};

function Terms() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.logo}>PASS Profile™ 3.0</div>
          <h1 style={styles.h1}>Terms of Service</h1>
          <p style={styles.updated}>Last Updated: October 14, 2026</p>
        </div>
        
        <div style={styles.section}>
          <h2 style={styles.h2}>Welcome to PASS Profile 3.0</h2>
          <p style={styles.p}>
            These Terms of Service ("Terms") govern your use of the PASS Profile 3.0 
            assessment and services ("Service") operated by Ted's Voice Academy ("we," 
            "our," "us").
          </p>
          <p style={styles.p}>
            <strong>By using PASS Profile, you agree to these Terms.</strong> If you 
            don't agree, please don't use the Service.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>What PASS Profile Is (And Isn't)</h2>
          
          <h3 style={styles.h3}>PASS Profile IS:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>A professional communication assessment tool</li>
            <li style={styles.li}>A self-reflection resource for career development</li>
            <li style={styles.li}>A way to understand your communication tendencies in workplace settings</li>
            <li style={styles.li}>An educational tool for professional growth</li>
          </ul>
          
          <h3 style={styles.h3}>PASS Profile is NOT:</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>A psychological evaluation or diagnosis</li>
            <li style={styles.li}>A personality test or mental health assessment</li>
            <li style={styles.li}>A predictor of job performance or success</li>
            <li style={styles.li}>A substitute for professional counseling or therapy</li>
            <li style={styles.li}>A tool for making hiring, firing, or promotion decisions</li>
          </ul>
          
          <div style={styles.importantNotice}>
            <strong>Important:</strong> If you're experiencing mental health challenges, 
            please consult a qualified healthcare professional. PASS Profile is not 
            designed to address psychological or emotional concerns.
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Using the Service</h2>
          
          <h3 style={styles.h3}>Account Requirements</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>You must be at least 18 years old</li>
            <li style={styles.li}>You must provide accurate information</li>
            <li style={styles.li}>You're responsible for keeping your password secure</li>
            <li style={styles.li}>One account per person</li>
          </ul>
          
          <h3 style={styles.h3}>Acceptable Use</h3>
          <p style={styles.p}>You agree to:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Answer questions honestly based on your actual tendencies</li>
            <li style={styles.li}>Use results for personal/professional development only</li>
            <li style={styles.li}>Not share your login credentials</li>
            <li style={styles.li}>Not attempt to manipulate or game the assessment</li>
          </ul>
          
          <h3 style={styles.h3}>Prohibited Uses</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Using results to discriminate against anyone</li>
            <li style={styles.li}>Making hiring/firing decisions based solely on PASS results</li>
            <li style={styles.li}>Sharing assessment content without permission</li>
            <li style={styles.li}>Reverse-engineering the scoring algorithms</li>
            <li style={styles.li}>Using for any unlawful purpose</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Payments and Refunds</h2>
          
          <h3 style={styles.h3}>Pricing</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Current price: $49.99 per assessment</li>
            <li style={styles.li}>Prices may change (existing purchases honored)</li>
            <li style={styles.li}>Payment processed securely via Stripe</li>
          </ul>
          
          <h3 style={styles.h3}>What You Get</h3>
          <ul style={styles.ul}>
            <li style={styles.li}>Access to complete the 60-scenario assessment</li>
            <li style={styles.li}>Your personalized PDF report</li>
            <li style={styles.li}>Ability to download your report anytime</li>
          </ul>
          
          <h3 style={styles.h3}>Refund Policy</h3>
          <p style={styles.p}>
            <strong>30-day money-back guarantee</strong> if you're unsatisfied with your 
            results. Contact us at PASS@tedsvoiceacademy.com.
          </p>
          <p style={styles.p}>No refunds after:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>30 days from purchase date</li>
            <li style={styles.li}>Using the assessment results for commercial purposes</li>
            <li style={styles.li}>Sharing your report, or any page from it, with others</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Intellectual Property</h2>
          <p style={styles.p}>
            All assessment content, scoring algorithms, reports, and related materials 
            are proprietary to Ted's Voice Academy. You may not:
          </p>
          <ul style={styles.ul}>
            <li style={styles.li}>Copy or distribute assessment scenarios</li>
            <li style={styles.li}>Reverse-engineer the scoring system</li>
            <li style={styles.li}>Create derivative works</li>
            <li style={styles.li}>Use for commercial purposes without written permission</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Limitation of Liability</h2>
          <p style={styles.p}><strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</strong></p>
          <p style={styles.p}>Ted's Voice Academy is NOT liable for:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Decisions made based on assessment results</li>
            <li style={styles.li}>Emotional distress from receiving results</li>
            <li style={styles.li}>Career or relationship outcomes</li>
            <li style={styles.li}>Any indirect or consequential damages</li>
          </ul>
          <p style={styles.p}>You understand and agree that:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Results are based solely on self-reported responses</li>
            <li style={styles.li}>Professional guidance should supplement assessment results</li>
            <li style={styles.li}>We make no guarantees about accuracy or outcomes</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Professional Advice Disclaimer</h2>
          <p style={styles.p}><strong>PASS Profile does not constitute professional advice.</strong> For:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Career decisions: Consult a career counselor</li>
            <li style={styles.li}>Mental health concerns: Consult a licensed therapist</li>
            <li style={styles.li}>Medical issues: Consult a healthcare provider</li>
            <li style={styles.li}>Legal matters: Consult an attorney</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Data Privacy</h2>
          <p style={styles.p}>
            Your assessment data is governed by our <a href="/privacy" style={styles.inlineLink}>Privacy Policy</a>. 
            By using this Service, you consent to data collection and use as described 
            in the Privacy Policy.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Changes to Terms</h2>
          <p style={styles.p}>
            We may update these Terms at any time. Continued use of the Service after 
            changes constitutes acceptance. We will notify you of significant changes 
            via email.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Termination</h2>
          <p style={styles.p}>We may terminate your access if you:</p>
          <ul style={styles.ul}>
            <li style={styles.li}>Violate these Terms</li>
            <li style={styles.li}>Attempt to abuse or game the system</li>
            <li style={styles.li}>Use the Service for unlawful purposes</li>
          </ul>
          <p style={styles.p}>You may delete your account at any time, which will erase your data.</p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Governing Law</h2>
          <p style={styles.p}>
            These Terms are governed by the laws of Washington State, United States, 
            without regard to conflict of law principles.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Dispute Resolution</h2>
          <p style={styles.p}>
            Before filing any legal action, you agree to contact us at 
            PASS@tedsvoiceacademy.com to attempt to resolve the dispute informally.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Contact Information</h2>
          <p style={styles.p}>Questions about these Terms?</p>
          <p style={styles.p}>Email: <a href="mailto:PASS@tedsvoiceacademy.com" style={styles.inlineLink}>PASS@tedsvoiceacademy.com</a></p>
          <p style={styles.p}>Website: <a href="https://tedsvoiceacademy.com" style={styles.inlineLink}>www.tedsvoiceacademy.com</a></p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.h2}>Entire Agreement</h2>
          <p style={styles.p}>
            These Terms, along with our Privacy Policy, constitute the entire agreement 
            between you and Ted's Voice Academy regarding the Service.
          </p>
        </div>

        <div style={styles.legalFooter}>
          <p style={{...styles.p, marginBottom: 0}}>
            <strong>By using PASS Profile 3.0, you acknowledge that you have read, 
            understood, and agree to be bound by these Terms of Service.</strong>
          </p>
        </div>

        <div style={styles.backLink}>
          <a href="/" style={styles.link}>← Back to Home</a>
        </div>
      </div>
    </div>
  );
}

export default Terms;
